// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"a31fa0c9","484":"ea3d5361","498":"77624ea9","576":"797eae75","617":"3a8249bc","703":"a198b908"}[chunkId] + ".chunk.js";
};